import {ActionReducerMapBuilder, createSlice, type SliceSelectors, type SliceCaseReducers} from '@reduxjs/toolkit'

import {ProductBundleState, getInitialState} from '@web/slices/productBundle/slice'

type Options = {
    extraReducers?: (builder: ActionReducerMapBuilder<ProductBundleState>) => void
}

const makeSlice = (options?: Options) =>
    createSlice<
        ProductBundleState,
        SliceCaseReducers<ProductBundleState>,
        'productBundle',
        SliceSelectors<ProductBundleState>
    >({
        name: 'productBundle',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
        },
    })

export default makeSlice
